export const createSpeechRecognition = (options) => {
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  
  if (!SpeechRecognition) {
    throw new Error('Speech recognition not supported.');
  }

  const recognition = new SpeechRecognition();
  
  // Enhanced settings for better accuracy
  recognition.continuous = true;
  recognition.lang = options.language || 'en-US';
  recognition.interimResults = true;
  recognition.maxAlternatives = 1; // Use only the best alternative to avoid duplicates

  // Set up event handlers
  recognition.onresult = options.onResult;
  recognition.onerror = options.onError;
  recognition.onend = options.onEnd;
  recognition.onstart = options.onStart;
  recognition.onaudiostart = options.onAudioStart;
  recognition.onaudioend = options.onAudioEnd;
  recognition.onsoundstart = options.onSoundStart;
  recognition.onsoundend = options.onSoundEnd;
  recognition.onspeechstart = options.onSpeechStart;
  recognition.onspeechend = options.onSpeechEnd;

  return recognition;
};

export const startRecording = (recognition) => {
  try {
    recognition.start();
    return true;
  } catch (error) {
    console.error('Error starting speech recognition:', error);
    throw new Error('Error starting speech recognition. Please check microphone permissions.');
  }
};

export const stopRecording = (recognition) => {
  if (recognition) {
    recognition.stop();
  }
}; 